import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "./styles/approvals.css";
import { toast } from "react-toastify";

const ApprovalsPage = () => {
  const { type } = useParams(); // "invoices" or "payments"
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_URL = "https://receivablesbackend.onrender.com/api";

useEffect(() => {
  fetchRequests();
}, [type]);

// ✅ Move the fetch function outside so it’s reusable
const fetchRequests = async () => {
  try {
    setLoading(true);
const url =
  type === "payments"
    ? `${API_URL}/pending-credits`
    : `${API_URL}/pending-sales`;

    const res = await fetch(url);
    if (!res.ok) throw new Error("Failed to fetch");
    const allData = await res.json();

    // ✅ Filter pending approvals only
const pending = allData.filter(
  (item) =>
    item.status &&
    item.status.toLowerCase().includes("pending")
);

    setData(pending);
  } catch (err) {
    console.error(err);
    toast.error("Failed to fetch requests");
  } finally {
    setLoading(false);
  }
};

// ✅ Approve / Reject Handlers
const handleAction = async (id, action) => {
  try {
let approvalType = null;

// Map URL params to backend values
if (type === "invoices") approvalType = "invoice";
if (type === "payments") approvalType = "credit";

if (!approvalType) {
  toast.error("Invalid approval type");
  return;
}

const res = await fetch(`${API_URL}/approvals`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({
    type: approvalType,
    id,
    action,
  }),
});


    if (!res.ok) throw new Error("Failed to update");
    const result = await res.json();
    toast.success(result.message);

    // ✅ Now this works because fetchRequests is defined
    fetchRequests();
  } catch (err) {
    console.error("❌ Error updating:", err);
    toast.error("Error updating status");
  }
};


  return (
    <div className="approvals-container">
      <div className="approvals-header">
        <h2>{type === "invoices" ? "Invoice Approvals" : "Payment Approvals"}</h2>
        <button className="back-btn" onClick={() => navigate("/")}>← Back</button>
      </div>

      {loading ? (
        <p>Loading {type}...</p>
      ) : data.length === 0 ? (
        <p className="empty-msg">No pending {type} requests 🎉</p>
      ) : (
        <table className="approvals-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>{type === "invoices" ? "Client" : "Received From"}</th>
              {type === "invoices" ? (
                <>
                  <th>Amount</th>
                  <th>Due Date</th>
                </>
              ) : (
                <>
                  <th>Amount</th>
                  <th>Date</th>
                  <th>Mode</th>
                </>
              )}
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
<tr key={item.id}>
  <td>{item.id}</td>

  {/* CLIENT NAME MAPPED PROPERLY */}
  <td>
    {item.client_name ||
     item.customer_name ||
     item.client ||
     item.full_name ||
     item.customer ||
     item.client_external_id ||
     "Unknown"}
  </td>

  {/* AMOUNT */}
  <td>${Number(item.amount).toLocaleString()}</td>

  {/* DATE + MODE LOGIC */}
{type === "invoices" ? (
  <>
    {/* Show date_of_sale BEFORE approval, due_date AFTER approval */}
    <td>
      {item.due_date
        ? new Date(item.due_date).toLocaleDateString()
        : new Date(item.date_of_sale || item.date_created).toLocaleDateString()
      }
    </td>
  </>
) : (
  <>
    <td>{new Date(item.payment_date || item.date_created).toLocaleDateString()}</td>
    <td>{item.mode || item.payment_mode || "Credit"}</td>
  </>
)}


  {/* ACTION BUTTONS */}
  <td className="actions">
    <button
      className="approve"
      onClick={() => handleAction(item.id, "Approved")}
    >
      Approve
    </button>
    <button
      className="reject"
      onClick={() => handleAction(item.id, "Rejected")}
    >
      Reject
    </button>
  </td>
</tr>

            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default ApprovalsPage;
